var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.CInfoPageTemplate,{attrs:{"content-label":_vm.$t('enterprise.appointment.label'),"content-text":_setup.getNoticeContent,"button-text":_vm.$t('enterprise.appointment.action-button')},on:{"button-click":_setup.goAppointment}})
}
var staticRenderFns = []

export { render, staticRenderFns }